// src/components/Logo.js
import React from "react";
import { Box, Link, ImageList, ImageListItem } from "@mui/material";
import theme from "../styles/themes/theme";

const Logo = () => {
  const homepageUrl = "https://www.alphabetsigns.com";

  return (
    <ImageList>
      <ImageListItem>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mr: {
              xs: theme.spacing(1),
              sm: theme.spacing(2),
              md: theme.spacing(3),
            },
            width: "100%",
            aspectRatio: "15/2",
            [theme.breakpoints.down("sm")]: {
              width: "120%",
            },
            [theme.breakpoints.up("md")]: {
              width: "75%", 
            },
          }}
        >
          <Link href={homepageUrl} underline="none">
            <img
              src="https://www.alphabetsigns.com/mm5/graphics/00000001/alphabet-signs-logo-450.png"
              alt="alphabet signs logo"
              style={{
                objectFit: "cover",
                width: "100%",
                height: "100%",
              }}
            />
          </Link>
        </Box>
      </ImageListItem>
    </ImageList>
  );
};

export default Logo;
